const NAMESPACE = 'webapp/';

export default {
  ROUTE_CHANGED: `${NAMESPACE}ROUTE_CHANGED`,
};
